import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from '../Layout';
import { Dashboard, AboutUs, NotFound, ContactUs, ProjectsPage, LogoRevealLuxuria, PrivacyPolicy, Blogs, BlogDetails } from "../Pages/Exports";
import Footer from "../Layout/Footer";



const router = createBrowserRouter([


    {
      element: <Layout />,
      children: [
        {
          path: "/",
          element: <Dashboard />,
        },

        {
          path: "/about",
          element: <AboutUs />,
        },

        {
          path : '/contactus',
          element : <ContactUs />,
        },

        {
          path: "/blogs",
          element: <Blogs />
        },

        {
          path: "/blogs/:id",
          element: <BlogDetails />
        },

        {
          path: "/privacy-policy",
          element : <PrivacyPolicy />
        },
        
      ],
    },
  {
    path: "/luxor-exclusive",
    element: <ProjectsPage />,
  },
  {
    path: '/luxuria',
    element: <LogoRevealLuxuria />,
  },

  
  {
    path: "*",
    element: <Navigate  to="/" replace />,
  },
]);

export default router;











// <?xml version="1.0" encoding="UTF-8"?>
// <urlset
//       xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"
//       xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
//       xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9
//             http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">


// <url>
//   <loc>https://kollagroup.com/</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>1.00</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/our-story</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.80</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/kolla-experience</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.80</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/our-projects</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.80</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/career</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.80</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/contact-us</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.80</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/project-details?url=kolla-luxuria</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.80</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/disclaimer.php</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.80</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/index_kolla.php?blog=1</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.64</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/project-details.php?url=kolla-luxuria</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.64</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/project-details.php?url=kolla-luxor-heights</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.64</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/project-details.php?url=kolla-luxor-park</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.64</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/project-details.php?url=madhavapuri-township</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.64</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/project-details.php?url=parkview-enclave</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.64</priority>
// </url>
// <url>
//   <loc>https://kollagroup.com/our-projects.php</loc>
//   <lastmod>2021-02-04T07:15:57+00:00</lastmod>
//   <priority>0.64</priority>
// </url>


// </urlset>